export default __webpack_public_path__ + "static/media/card6.e8bd3dc6.jpg";